import React from "react";
import { Box, Typography } from "@mui/material";

interface DeliveryTableCellProps {
  title: React.ReactNode;
  subTitle?: string;
  widthValue?: string;
}

const DeliveryTableCell: React.FC<DeliveryTableCellProps> = ({
  title,
  subTitle,
}) => {
  return (
    <Box>
      <Typography fontSize={14} fontWeight={500} color={"shadesOfDark.dark"}>
        {title}
      </Typography>
      <Typography fontSize={12} fontWeight={400} color={"shadesOfDark.steel"}>
        {subTitle}
      </Typography>
    </Box>
  );
};

export default DeliveryTableCell;
